export const LIMIT = 25;
export const RESERVATION_SECTIONS = ['details', 'screenshots'];
export const NEED_RESERVATION_SECTIONS = ['details', 'restaurants', 'screenshots'];
export const MONTHS_INTERVAL_OPS = [0, 1, 2, 5, 11];
